import $ from "jquery";
const $hamburger_menu = $(".hamburger");
const $menu_container = $(" header .wp-classic-menu-block ");
const $menu_children_items = $("#menu-main-menu >.menu-item-has-children >a");
const $window = $(window);

const backButtonFunctionality = () =>
  $(".back-button").on(
    "click",
    (e) =>
      e.stopPropagation() ||
      $(".sub-menu, .menu-menu-1-container").removeClass("show-sub-menu")
  );

$menu_children_items.on("click", (e) => {
  e.preventDefault();
  const $this = $(e.currentTarget);
  if ($window.innerWidth() < 1200) {
    if (!$this.next().find(".nav-back-button").length) {
      $this
        .next()
        .prepend(
          $('<div class="nav-back-button">')
            .append("<div class='back-button'>Back</div>")
            .append($('<div class="nav-mobile-title">').text($this.text()))
        );
      backButtonFunctionality();
    }
    if ($this.next().hasClass("show-sub-menu")) {
      // Close the clicked sub-menu
      $this.next().removeClass("show-sub-menu");
      $menu_container.removeClass("show-sub-menu");
    } else {
      $menu_children_items.not($this).next().removeClass("show-sub-menu"); // Remove 'show-sub-menu' class from other menu items
      // Show the clicked sub-menu
      $this.next().addClass("show-sub-menu");
      $menu_container.addClass("show-sub-menu");
    }
  } else {
    $menu_children_items.not($this).parent().removeClass("open");
    $this.parent().toggleClass("open");
  }
});

$hamburger_menu.on("click", (e) => {
  const $this = $(e.currentTarget);
  $this.toggleClass("is-active");
  $menu_container.toggleClass("show");
  $("html").toggleClass("menu-open");
});

$("header .depth-0").each(function () {
  var $prevAnchor = $(this).prev("a");
  if ($prevAnchor.length) {
    var href = $prevAnchor.attr("href");
    var text = $prevAnchor.text();
    var $menuTitle = $('<div class="menu-title"></div>');
    $menuTitle.append(
      '<a href="' + href + '">' + text + "<span>View All</span></a>"
    );

    // Insert the new .menu-title div inside the .depth-0 element
    $(this).append($menuTitle);
  }
});

$window.on("resize load", () =>
  $(":root").css("--nav-height", `${$("header").innerHeight()}px`)
);

$(".header-contact-container_icons").on("click", () =>
  $(".header-contact-container").toggleClass("show")
);
